<template>
  <div class="mb-1">
    <v-layout row>
      <v-flex xs6 class="text-xs-center">
        <template v-if="cifItem.rapoarte && JSON.stringify({}) !== JSON.stringify(cifItem.rapoarte)">
          <div style="height: 40vh; overflow-y: auto">
            <v-list dense three-line subheader>
              <v-subheader class="success--text" d-flex style="justify-content: space-between">
                Rapoarte generate &nbsp;
                <a @click="toggleSelectAll">{{rapoarteGenerate.length === selectedReports.length ? 'deselecteaza' : 'selecteaza'}} tot</a>
              </v-subheader>
              <v-list-tile v-for="raport in rapoarteGenerate" :key="`${raport.reportId}_${raport.lang}-generat`" @click="dummy">
                <v-list-tile-action>
                  <v-icon color="primary">{{raport.public ? 'mdi-parking' : 'mdi-file-multiple'}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content @click="toggleRaport(raport)" class="pr-2">
                  <v-list-tile-title class="text-no-wrap text-truncate">
                    ({{raport.denumire}}) {{translateUI(raport.denumire, raport.lang)}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text-no-wrap text-truncate">
                    ({{raport.detalii}}) {{translateUI(raport.detalii, raport.lang)}}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title style="display: flex; align-items: center">
                    <template v-if="raport.lang === 'en'">
                      <flag iso="us" :squared="false" class="mr-0"/>
                      /
                      <flag iso="gb" :squared="false" class="mr-1" />
                    </template>
                    <template v-else>
                      <flag :iso="raport.lang" :squared="false" class="mr-1" />
                    </template>
                    <v-icon
                      class="mx-2"
                      small
                      :title="raport.vizibil ? 'vizibil' : 'invizibil'"
                      :color="raport.vizibil ? 'success' : 'error'">
                      {{raport.vizibil ? 'mdi-eye' : 'mdi-eye-off'}}
                    </v-icon>
                    <span class="font-weight-bold mr-2">{{raport.perioada}}</span>
                    <span>{{formatDate(raport.data)}}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="selectedReports"
                    :value="raport"
                    color="accent"
                    hide-details>
                  </v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </div>
          <v-btn :disabled="!selectedReports.length" @click="_cbDownloadReports(cifItem)" color="primary">
            Descarca {{selectedReports.length}} {{selectedReports.length === 1 ? 'raport' : 'rapoarte'}}
          </v-btn>
        </template>
        <p v-else class="ma-2 subheading text-xs-center">Nu exista rapoarte!</p>
      </v-flex>
      <v-divider inset vertical class="ma-0"></v-divider>
      <v-flex xs6 class="text-xs-center">
        <div style="height: 40vh; overflow-y: auto">
          <v-list dense three-line subheader>
            <v-subheader class="error--text" d-flex style="justify-content: space-between">
              Rapoarte negenerate
              <a @click="toggleSelectAllNegenerate">{{rapoarteNegenerate.length / langs.length === selectedReportsToGenerate.length ? 'deselecteaza' : 'selecteaza'}} tot</a>
            </v-subheader>
            <v-list-tile v-for="(raport, raportId) in rapoarteNegenerate" :key="raportId + 'negenerat'">
              <v-list-tile-action>
                <v-icon color="error">{{raport.public ? 'mdi-parking' : 'mdi-file-multiple'}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="text-no-wrap text-truncate">
                  ({{raport.denumire}}) {{translateUI(raport.denumire, raport.lang)}}
                </v-list-tile-title>
                <v-list-tile-sub-title class="text-no-wrap text-truncate">
                  ({{raport.detalii}}) {{translateUI(raport.detalii, raport.lang)}}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title style="display: flex; align-items: center">
                  <template v-if="raport.lang === 'en'">
                    <flag iso="us" :squared="false" class="mr-0"/>
                    /
                    <flag iso="gb" :squared="false" class="mr-1" />
                  </template>
                  <template v-else>
                    <flag :iso="raport.lang" :squared="false" class="mr-1" />
                  </template>
                  <v-icon
                    class="mx-2"
                    small
                    :title="raport.vizibil ? 'vizibil' : 'invizibil'"
                    :color="raport.vizibil ? 'success' : 'error'">
                    {{raport.vizibil ? 'mdi-eye' : 'mdi-eye-off'}}
                  </v-icon>
                  <span class="font-weight-bold text-no-wrap" style="display: inline-block">{{raport.perioada}}</span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox
                  v-model="selectedReportsToGenerate"
                  :value="raport.reportId"
                  color="accent"
                  hide-details>
                </v-checkbox>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
        <v-btn :disabled="!selectedReportsToGenerate.length" @click="buildReports" color="primary">
          Genereaza {{selectedReportsToGenerate.length}} {{selectedReportsToGenerate.length === 1 ? 'raport' : 'rapoarte'}}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import streamSaver from 'streamsaver'
import moment from 'moment'
import translate from '@/mixins/Translate'

export default {
  name: 'rapoarte-cif',
  mixins: [translate],
  props: {
    cifItem: {
      type: Object,
      required: true
    },
    perioada: {
      type: String,
      required: true
    }
  },
  data: () => ({
    selectedReports: [],
    selectedReportsToGenerate: []
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    langs () {
      return this.$store.getters['dictionar/languages']
    },
    rapoarteNegenerate () {
      let rapoarteNegenerate = []
      const rapoarte = this.$store.getters['rapoarte/items']
      const keys = this.cifItem.rapoarte ? Object.keys(this.cifItem.rapoarte) : []

      rapoarte.forEach(raport => {
        this.langs.forEach(lang => {
          if (!keys.includes(`${raport._id}_${lang}`) && ((raport.laperioada && raport.perioade.includes(this.perioada.split('-')[1])) || !raport.laperioada)) {
            rapoarteNegenerate.push({
              denumire: raport.denumire,
              detalii: raport.detalii,
              folder: raport.folder,
              lang: lang,
              perioada: this.perioada,
              public: raport.public,
              reportId: raport._id,
              vizibil: raport.vizibil,
              zip: ''
            })
          }
        })
      })

      return rapoarteNegenerate.sort((a, b) => a.denumire.localeCompare(b.denumire))
    },
    rapoarteGenerate () {
      if (this.cifItem.rapoarte) {
        const rapoarte = []
        for (const raport in this.cifItem.rapoarte) rapoarte.push(this.cifItem.rapoarte[raport])

        return rapoarte.sort((a, b) => a.denumire.localeCompare(b.denumire))
      }

      return []
    }
  },
  methods: {
    dummy () {},
    formatDate (date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss') : '-'
    },
    toggleRaport (raport) {
      const index = this.selectedReports.findIndex(rap => rap === raport)
      if (index > -1) {
        this.selectedReports.splice(index, 1)
      } else {
        this.selectedReports.push(raport)
      }
    },
    translate (head, value) {
      switch (head) {
        case 'cif_op': return this.translateUI('Card_5', this.lang)
        case 'cif_os': return this.translateUI('Card_6', this.lang)
        case 'capita': return this.translateUI('Card_7', this.lang)
        case 'tip_apl': {
          switch (value) {
            case 'Judet': return this.translateUI('Card_1', this.lang)
            case 'Municipiu': return this.translateUI('Card_2', this.lang)
            case 'Oras': return this.translateUI('Card_3', this.lang)
          }
          break
        }
        case 'raport': return this.translateUI(value === 'Raport' ? 'Raport' : 'Rapoarte', this.lang)
      }
    },
    _cbDownloadReports (cifItem) {
      if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
        streamSaver.mitm = `${this.host}/mitm.html`
      }
      // const fileStream = createWriteStream(report.zip)
      const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_${cifItem.cif_op}_${cifItem.cif_op}_${this.selectedReports.length}_${this.selectedReports.length > 1 ? this.translate('raport', 'Rapoarte') : this.translate('raport', 'Raport')}.zip`)
      fetch(`${this.host}/smb-raport`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ reports: this.selectedReports, cifop: cifItem.cif_op, cifos: cifItem.cif_os })
      })
        .then(res => {
          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream).then(() => console.log('done writing'))
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => {
            if (done) {
              // close the stream so we stop writing
              writer.close()
            } else {
              // Write one chunk, then get the next one
              writer.write(value).then(pump)
            }
          })

          // Start the reader
          pump().then(() => {
            console.log('Closed the stream, Done writing')
          })
        })
        .catch(err => {
          this.error = true
          console.log(err)
        })
    },
    buildReports () {
      const payload = {
        rapoarte: [...this.selectedReportsToGenerate],
        cifuri: [this.cifItem._id],
        types: [],
        perioade: []
      }

      this.selectedReportsToGenerate = []

      this.$store.dispatch('rapoarte/processReports', payload)
    },
    toggleSelectAll () {
      if (this.selectedReports.length === this.rapoarteGenerate.length) {
        this.selectedReports = []
      } else {
        this.selectedReports = [...this.rapoarteGenerate]
      }
    },
    toggleSelectAllNegenerate () {
      if (this.selectedReportsToGenerate.length === this.rapoarteNegenerate.length / this.langs.length) {
        this.selectedReportsToGenerate = []
      } else {
        const set = new Set()
        this.rapoarteNegenerate.forEach(raport => (set.add(raport.reportId)))
        this.selectedReportsToGenerate = [...set]
      }
    }
  },
  created () {
    this.$store.dispatch('rapoarte/fetchItems')
  }
}
</script>
